import { YoutubeIcon } from '@/assets/social-icons/YoutubeIcon';
import { TripAdvisorIcon } from '@/assets/social-icons/TripAdvisorIcon';
import { GoogleIcon } from '@/assets/social-icons/GoogleIcon';
import { InstagramIcon } from '@/assets/social-icons/InstagramIcon';
import { FacebookIcon } from '@/assets/social-icons/FacebookIcon';
import { TiktokIcon } from '@/assets/social-icons/TiktokIcon';

import {
  AFRICA_SAFARI_FACEBOOK,
  AFRICA_SAFARI_INSTAGRAM,
  AFRICA_SAFARI_TRIP_ADVISOR,
  LanguageEnum,
  TANZANIA_SPECIALIST_FACEBOOK,
  TANZANIA_SPECIALIST_INSTAGRAM,
  TANZANIA_SPECIALIST_TRIP_ADVISOR,
} from 'utils/constants.ts';

export const getTSSocialMediaByLanguage = (language: LanguageEnum) => {
  return [
    {
      icon: YoutubeIcon,
      link: 'https://www.youtube.com/channel/UC3_63AcZOwnQPHjbOb25uKg/videos',
      label: 'YouTube',
    },
    {
      icon: TripAdvisorIcon,
      link: TANZANIA_SPECIALIST_TRIP_ADVISOR[language],
      label: 'Trip Advisor',
    },
    {
      icon: GoogleIcon,
      link: 'https://www.google.com/search?q=tanzania+specialist',
      label: 'Google',
    },
    {
      icon: InstagramIcon,
      link: TANZANIA_SPECIALIST_INSTAGRAM[language],
      label: 'Instagram',
    },
    {
      icon: FacebookIcon,
      link: TANZANIA_SPECIALIST_FACEBOOK[language],
      label: 'Facebook',
    },
    {
      icon: TiktokIcon,
      link: 'https://www.tiktok.com/@tanzaniaspecialist?_r=1&_t=ZN-91h3MYhzEcY',
      label: 'Tiktok',
    },
  ];
};

export const getASSocialMediaByLanguage = (language: LanguageEnum) => {
  return [
    {
      icon: YoutubeIcon,
      link: 'https://www.youtube.com/@AfricaSafariTrips/videos',
      label: 'Youtube',
    },
    {
      icon: TripAdvisorIcon,
      link: AFRICA_SAFARI_TRIP_ADVISOR[language],
      label: 'Trip Advisor',
    },
    {
      icon: GoogleIcon,
      link: 'https://www.google.com/search?q=africa+safari+trips',
      label: 'Google',
    },
    {
      icon: InstagramIcon,
      link: AFRICA_SAFARI_INSTAGRAM[language],
      label: 'Instagram',
    },
    {
      icon: FacebookIcon,
      link: AFRICA_SAFARI_FACEBOOK[language],
      label: 'Facebook',
    },
    {
      icon: TiktokIcon,
      link: 'https://www.tiktok.com/@africasafaritrips.com?_r=1&_t=ZN-91h3PjpW8uN',
      label: 'Tiktok',
    },
  ];
};

export const getLinkByLanguage = (target: Record<LanguageEnum, string>, language: LanguageEnum) => target[language];
